<template>
  <!-- 保单状态显示组件 子状态合并显示 -->
  <div v-if="formData">
    <lzDicTxt dicType="POLICY_STATUS" :dicCode="formData.status" />
    <span v-if="formData.subStatus">-</span>
    <lzDicTxt dicType="POLICY_SUB_STATUS" :dicCode="formData.subStatus" />
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  components: { lzDicTxt },
  props: {
    formData: null,
  },
  data() {
    return {
    };
  },
};
</script>
